import React from 'react'
import GeneralServices from '../../app/service/generalServices'
import CustomCalendar from '../calendar/customCalendar'
import { Button } from 'primereact/button'
import TooltipButton from '../tooltipButton'
import * as popUp from '../toastr'
import QuantidadeParcelasComponent from '../contasAPagar/quantidadeParcelasComponent'
import { InputMask } from 'primereact/inputmask'
import SelectMenu from '../selectMenu'
import ProductService from '../../app/service/productService'
import FormGroup from '../form-group'
import ConstantsUtil from '../../context/constantsUtil'
import InputChooseFornecedor from '../contasAPagar/inputChooseFornecedor'
import { InputNumber } from 'primereact/inputnumber'
import BuyProductService from '../../app/service/buyProductService'
import HandleErrorService from '../../app/service/handleErrorService'
import NotaFiscalDTO from '../../dominio/nf/NotaFiscalDTO'
import ItensNFComponent from './itensNFComponent'
import ValidacaoPedidosCompra from '../../views/transactions/validacaoPedidosCompra'
import { Dialog } from 'primereact/dialog'
import NFService from '../../app/service/estoque/NFService'
import FornecedorService from '../../app/service/contasAPagar/fornecedorService'

class DadosNFComponent extends React.Component {

    constructor(){
        super()
        this.productService = new ProductService()
        this.buyProductService = new BuyProductService()
        this.nfService = new NFService()
        this.fornecedorService = new FornecedorService()
        this.quantidadeParcelasComponentRef = React.createRef()
    }

    state = {
        dataEntrada: '',
        dataEntradaView: '',
        inputDateErrorClass: '',
        errorDateMessage: '',

        hour: '',
        inputHourErrorClass: '',
        errorHourMessage: '',

        numeroDocumento: '',

        complementoHistorico: '',

        valorTotalNF: null,
        inputValorTotalNFErrorClass: '',

        valorDescontoPorDevolucao: null,
        
        selectAcrescimoDesconto: '',
        
        valorAcrescimoDesconto: null,
        inputValorAcrescimoDescontoErrorClass: '',

        qtdParcelas: '',
        inputParcelasErrorClass: '',
        errorParcelasMessage: 'Informe a quantidade de Parcelas',

        pagamentoList: [],

        fornecedor: {},
        inputFornecedorErrorClass: '',

        qtdItens: '',
        inputQtdItensErrorClass: '',

        transactions: [],

        produtosCompraList: [],

        produtosPropriosList: [],

        didUpdated: false,
        forceProductListUpdate: false,

        displayPedidoCompraDialog: false,
        displayConfirmationRemovePedidosLink: false,
        pedidosLinkadosId: [],
        possuiIntegracaoApiPedidosCompra: false,
        buscandoPedidosComprasLinkados: false,

    }

    componentDidMount(){
        this.setStates()
    }
    
    setStates = () => {
        // console.log("this.props.NFToValidate.transactions ", this.props.NFToValidate.transactions)
        this.resetView()
        this.resetData()
        
        if(this.props.insideValidateNFDialog){
            this.setDataEntrada()
        }

        this.setCurrentHour()
        
        this.setTransactions()
        
        this.trataDadosProvisao()

        if(this.props.isNFSaida){
            this.searchProdutosProprios()
        }

        this.verificaIntegracaoPedidosCompra()

    }

    verificaIntegracaoPedidosCompra = () => {
        this.nfService.verificaIntegracaoPedidosCompra()
        .then(response => {
            // console.log('verificaIntegracaoPedidosCompra: ', response.data)
            if(response.data){
                this.setState({possuiIntegracaoApiPedidosCompra: true})
                if(this.props.insideValidateNFDialog){
                    this.buscaPossiveisPedidosCompraLinkadosNF(this.props.NFToValidate.id)
                }
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    buscaPossiveisPedidosCompraLinkadosNF = nfId => {
        this.setState({buscandoPedidosComprasLinkados: true})
        this.nfService.buscaPossiveisPedidosCompraLinkadosNF(nfId)
        .then(response => {
            this.setState({pedidosLinkadosId: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({buscandoPedidosComprasLinkados: false})
        })
    }

    resetView = () => {
        this.setState({inputDateErrorClass: ""})
        this.setState({errorDateMessage: ""})
        
        this.setState({inputHourErrorClass: ''})
        this.setState({errorHourMessage: ''})

        this.setState({inputValorTotalNFErrorClass: ''})

        this.setState({inputValorAcrescimoDescontoErrorClass: ''})

        this.setState({inputParcelasErrorClass: ''})

        this.state.pagamentoList.forEach(pagamentoItem => {
            pagamentoItem.inputDateErrorClass = ''
            pagamentoItem.inputValorErrorClass = ''
        })

        this.setState({inputFornecedorErrorClass: ''})
        this.setState({inputQtdItensErrorClass: ''})

        this.state.transactions.forEach(transaction => {
            transaction.inputSelectProdutoErrorClass = ""
            transaction.inputTipoProdutoErrorClass = ""
            transaction.inputTipoEstoqueErrorClass = ""
            transaction.inputValorErrorClass = ""
            transaction.inputQuantidadeProdutoErrorClass = ""
        })
    }

    resetData = () => {
        this.setState({dataEntrada: ''})
        this.setState({dataEntradaView: ''})

        this.setState({hour: ''})

        this.setState({selectAcrescimoDesconto: ''})
        this.setState({valorAcrescimoDesconto: null})

        this.setState({qtdParcelas: ''})
        this.setState({pagamentoList: []})

        this.setState({transactions: []})
    }

    setDataEntrada = () => {
        // console.log("this.props.NFToValidate: ", this.props.NFToValidate)
        if(this.props.NFToValidate && this.props.NFToValidate.dataEntradaSemHorario){
            let dataEntradaSemHorario = this.props.NFToValidate.dataEntradaSemHorario
            this.setState({dataEntrada: dataEntradaSemHorario})
            this.setState({dataEntradaView: GeneralServices.convertBrStringToJsDate(dataEntradaSemHorario)})
        }
    }

    setCurrentHour = () => {
        /*
        Pré-preenche hora de entrada com horário atual na tela de validação das NFs
        */
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0'); // Obtém as horas e as converte para string, garantindo que tenham sempre dois dígitos
        const minutes = now.getMinutes().toString().padStart(2, '0');
        let currentStringHour = `${hours}:${minutes}`
        this.setState({hour: currentStringHour})
    }

    setTransactions = () => {
        if(this.props.NFToValidate && this.props.NFToValidate.transactions) {
            let transactionList = []
            this.props.NFToValidate.transactions.forEach(transaction => {
                // console.log("setTransactions: ", transaction)
                transaction.inputErrorClass = ""
                transaction.errorMessage = "Selecione o Tipo do Produto"
                if(!transaction.tipoProduto){
                    transaction.tipoProduto = transaction.productInfo.tipoProduto
                }
                if(!transaction.tipoEstoque){
                    transaction.tipoEstoque = transaction.productInfo.tipoEstoque
                }
                transactionList.push(transaction)
            })
            this.setState({transactions: transactionList})
        }
    }
    
    trataDadosProvisao = () => {
        // console.log("NFToValidate: ", this.props.NFToValidate)
        let provisao = this.props.NFToValidate && this.props.NFToValidate.provisao
        if(provisao){
            provisao.parcelaProvisaoList.forEach(parcela => {
                parcela.dataView = GeneralServices.convertBrStringToJsDate(parcela.data)
            })
        }
    }

    handleDateChange = async (event) => {

        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        const nameView = name+"View"
        await this.setState({[nameView]: value })

        // if(!this.props.insideValidateNFDialog){
        //     this.setDateInTransactions()
        // }

        // console.log("this.state.dataEntrada: ", this.state.dataEntrada)
        // console.log("this.state.dataEntradaView: ", this.state.dataEntradaView)
    }

    handleHourChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })

        if(!this.props.insideValidateNFDialog){
            this.setDateInTransactions()
        }

        // console.log("hour: ", this.state.hour)
    }

    setDateAndTipoInTransactions = async () => {
        const date = this.state.dataEntrada ? this.state.dataEntrada : ''
        const hour = this.state.hour ? this.state.hour : ''
        const compositeDate = `${date} - ${hour}`

        let transactions = this.state.transactions

        transactions.forEach(transaction => {
            transaction.dhEmi = compositeDate
            transaction.tipo = this.props.isNFSaida ? ConstantsUtil.saidaLabel : ConstantsUtil.entradaLabel
        })

        await this.setState({transactions})

        // console.log("after setDateInTransactions: ", this.state.transactions)
    }

    handleSelectAcrescimoDescontoChange = (event) => {
        this.handleChange(event)
        this.setState({valorAcrescimoDesconto: null})
    }

    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleNumeroChange = async (event) => {
        let value = event.target.value
        const name = event.target.name

        if(value && value < 0){
            value*=-1
        }

        this.setState({[name]: value})
        
    }

    handleValorChange = (event) => {
        // console.log("event: ", event)
        let value = event.value
        if(value === 0){
            value = null
        }
        const name = event.target.name
        this.setState({ [name]: value })
    }    

    handleSelectionFornecedorChange = async (fornecedor) => {

        // console.log("handleSelectionFornecedorChange: ", fornecedor, this.quantidadeParcelasComponentRef.current)
        this.setaFormaDePagamentoFromFornecedor(fornecedor)

        await this.setState({fornecedor})

        if(!this.state.qtdItens) {
            this.handleQuantidadeItensChange({target: {value: 1}})
        }

        let transactions = this.state.transactions
        transactions.forEach(transaction => {
            transaction.productInfo = {}
        })
        await this.setState({transactions})
        // console.log("this.state.transactions: ", this.state.transactions)
        this.searchProdutosCompra()
    }

    setaFormaDePagamentoFromFornecedor = (fornecedor) => {
        
        this.fornecedorService.buscaFormaDePagamentoSalva(fornecedor.id)
        .then(response => {
            if(response.data){
                this.quantidadeParcelasComponentRef.current.setFormaDePagamento(response.data)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    searchProdutosCompra = () => {
        this.buyProductService.searchBuyProductByFornecedor(this.state.fornecedor.id)
        .then(response => {
            var produtosCompraList = response.data
            this.setState({produtosCompraList})
            this.setState({forceProductListUpdate: true})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    searchProdutosProprios = () => {
        this.productService.search()
        .then(response => {
            this.setState({produtosPropriosList: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    handleQuantidadeItensChange = async (event) => {
        let value = event.target.value
        if(value && value < 0){
            value*=-1
        }

        const qtdItens = value;
        
        await this.setState({ qtdItens: value })

        var transactions = this.state.transactions
        
        if(qtdItens && qtdItens !== 0) {

            var initialIndex = 0
            var shouldExecuteLoop = true

            if(transactions && transactions.length > 0) {
                if(qtdItens > transactions.length) {
                    initialIndex = transactions.length
                }
                else {
                    transactions = transactions.slice(0, transactions)
                    shouldExecuteLoop = false
                }

            }
            else {
                transactions = []
            }
            if(shouldExecuteLoop){
                for(var i = initialIndex; i < this.state.qtdItens; i++){
                    transactions.push(
                        {
                            dhEmi: i+1,
                            productInfo: {},
                            inputSelectProdutoErrorClass: '',
                            tipoProduto: '',
                            inputTipoProdutoErrorClass: '',
                            inputTipoEstoqueErrorClass: '',
                            quantidade: '',
                            inputQuantidadeProdutoErrorClass: '',
                            valor: null,
                            inputValorProdutoErrorClass: '',
                        }
                    )
                }
            }

        }
        else{
            transactions = []
        }
        
        await this.setState({transactions})
        // console.log('this.state.transactions', this.state.transactions)

    }

    handleSelectionProductChange = (selectedProduct, currentTransaction, index) => {
        // console.log("selectedProduct: ", selectedProduct)
        currentTransaction.productInfo = selectedProduct
        currentTransaction.tipoProduto = selectedProduct.tipoProduto ? selectedProduct.tipoProduto : ""
        currentTransaction.tipoEstoque = selectedProduct.tipoEstoque ? selectedProduct.tipoEstoque : ""
        let transactions = this.state.transactions
        transactions[index] = currentTransaction
        this.setState({transactions})
    }

    handleTipoProdutoChange = (index, selectedTipoProduto, attribute) => {

        /*
        attribute pode ser tipoProduto ou tipoEstoque ou tipoProdutoContaGerencial
        */

        let transactionList = this.state.transactions
        let transaction = transactionList[index]
        transaction[attribute] = selectedTipoProduto
        
        this.state.transactions.forEach(transaction => {
            if(!transaction[attribute]){
                transaction[attribute] = selectedTipoProduto
            }
        })
        this.setState({transactions: transactionList})
    }

    handleQuantidadeItemLoopChange = async (event, index) => {

        let value = event.target.value
        if(value && value < 0){
            value*=-1
        }
        
        var transactions = this.state.transactions

        var obj = transactions[index]
        obj.quantidade = value

        transactions[index] = obj

        await this.setState({transactions})

        // console.log("this.state.pagamentoList", this.state.pagamentoList)
    }    

    handleValorItemLoopChange = async (event, index) => {

        var value = event.target.value
        // value = GeneralServices.convertJSDateToBrDate(value)
        
        var transactions = this.state.transactions

        var obj = transactions[index]
        obj.valor = value

        transactions[index] = obj

        await this.setState({transactions})

        // console.log("this.state.pagamentoList", this.state.pagamentoList)
    }

    checkApenasTipoProdutoETipoEstoque = () => {

        let check = true

        if(!this.props.emprestimo){

            let transactions = this.state.transactions

            transactions.forEach(transaction => {

                if(!transaction.productInfo || JSON.stringify(transaction.productInfo) === '{}') {
                    transaction.inputSelectProdutoErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
    
                if(!transaction.tipoProduto){
                    transaction.inputTipoProdutoErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
    
                if(!transaction.tipoEstoque){
                    transaction.inputTipoEstoqueErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
    
            })

            this.setState({transactions})

        }

        if(!check){
            popUp.warningPopUp("Preencha todas as informações.")
        }

        return check

    }

    checkData = () => {

        // console.log("checkData dadosNFComponent transactions: ", this.state.transactions)
        
        this.resetView()

        var check = true

        if(!this.state.dataEntrada){
            this.setState({inputDateErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorDateMessage: ConstantsUtil.informeDataErrorMenssage})
            check = false
        }
        
        if(!GeneralServices.checkValidHour(this.state.hour)){
            this.setState({inputHourErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorHourMessage: "Informe um horário válido"})
            check=false
        }

        if(!this.state.valorTotalNF && !this.props.insideValidateNFDialog && !this.props.emprestimo){
            this.setState({inputValorTotalNFErrorClass: ConstantsUtil.primereactInputErrorClass})
            check = false
        }

        if(this.state.selectAcrescimoDesconto && !this.state.valorAcrescimoDesconto) {
            this.setState({inputValorAcrescimoDescontoErrorClass: ConstantsUtil.primereactInputErrorClass})
            check = false
        }

        if(GeneralServices.isEmptyObject(this.state.fornecedor) && !this.props.insideValidateNFDialog && !this.props.isNFSaida){
            this.setState({inputFornecedorErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check=false
        }

        if( (!this.state.qtdItens || this.state.qtdItens <= 0) && !this.props.insideValidateNFDialog){
            this.setState({inputQtdItensErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        let valorTotalProdutos = 0
        let checkSomatorio = true

        if(!this.props.emprestimo){
            this.state.transactions.forEach(transaction => {
                if(!transaction.productInfo || JSON.stringify(transaction.productInfo) === '{}') {
                    transaction.inputSelectProdutoErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
    
                if(!transaction.tipoProduto){
                    transaction.inputTipoProdutoErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
    
                if(!transaction.tipoEstoque){
                    transaction.inputTipoEstoqueErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
                
                if(!transaction.quantidade){
                    transaction.inputQuantidadeProdutoErrorClass = ConstantsUtil.bootstrapInputErrorClass
                    check = false
                }
                
                if(!transaction.valor && !this.props.insideValidateNFDialog){
                    transaction.inputValorErrorClass = ConstantsUtil.primereactInputErrorClass
                    check = false
                }
                else {
                    valorTotalProdutos += transaction.valor
                }
    
            })
        }

        if(!this.props.insideValidateNFDialog && !this.props.emprestimo){
            /*
                Não é tela de validação de NFs. Então é tela de lançamento manual de NF.
                Apenas nessa situação é que confere o somatório do valor dos produtos em relação ao valor total da NF.
                Na tela de validação de NF, confere apenas o valor das parcelas de pagamento em relação ao valro total da NF,
                uma vez que na tela de validação de NFs, tanto o valor total das NFs quanto o valor dos produtos já é fixo e
                preenchido pela importação do XML.
            */
            if(
                GeneralServices.formatTo2CasasDecimais(valorTotalProdutos)
                // !== GeneralServices.formatTo2CasasDecimais(this.getValorTotal() + this.getRealValorAcrescimoDesconto())
                !== GeneralServices.formatTo2CasasDecimais(this.getValorTotal())
            )
            {
                popUp.warningPopUp("Somatório do valor dos Produtos diferente do Valor Total da NF.")
                checkSomatorio = false
            }
        }

        let checkQuantidadeParcelasComponent = {checkGeral: true, apenasCheckSomatorioFalhou: false}
        if(!this.props.isNFSaida && !this.props.emprestimo){
            checkQuantidadeParcelasComponent = this.quantidadeParcelasComponentRef.current.checkData()
        }

        let resultCheck = check && checkSomatorio && checkQuantidadeParcelasComponent.checkGeral

        let apenasCheckSomatorioFalhou = !resultCheck && (check && checkQuantidadeParcelasComponent.apenasCheckSomatorioFalhou)

        if(!resultCheck && !apenasCheckSomatorioFalhou){
            popUp.warningPopUp("Preencha todas as informações.")
        }
        
        return resultCheck
        // return false
    }

    montaNF = () => {
        this.setDateAndTipoInTransactions()
        let notaFiscalDTO = new NotaFiscalDTO
        (
            `${this.state.dataEntrada} - ${this.state.hour}`,
            this.state.fornecedor,
            this.state.numeroDocumento,
            this.state.valorTotalNF,
            this.getRealValorAcrescimoDesconto(),
            this.getValorDescontoBonificacao(),
            this.state.valorDescontoPorDevolucao,
            this.props.isNFSaida ? ConstantsUtil.saidaLabel : ConstantsUtil.entradaLabel,
            55,
            this.state.transactions,
            this.props.isNFSaida ? null : this.quantidadeParcelasComponentRef.current.getResultObject(),
            this.state.complementoHistorico,
            this.props.emprestimo,
            this.state.pedidosLinkadosId
        )

        return notaFiscalDTO;
    }

    getColMdClasses = () => {
        if(this.props.insideValidateNFDialog){
            return {
                dataEntrada: 'col-md-6',
                horarioEntrada: 'col-md-6',
            }
        }
        else{
            return {
                dataEntrada: 'col-md-2',
                horarioEntrada: 'col-md-2',
            }
        }
    }

    getValorTotal = () => {
        if(this.props.insideValidateNFDialog){
            return this.props.NFToValidate ? this.props.NFToValidate.valorTotal : null
        }
        return this.state.valorTotalNF
    }

    getRealValorAcrescimoDesconto = () => {
        if(this.state.selectAcrescimoDesconto) {
            if(this.state.selectAcrescimoDesconto === ConstantsUtil.nfDescontoValue) {
                return this.state.valorAcrescimoDesconto*-1
            }
            return this.state.valorAcrescimoDesconto
        }
        return 0
    }

    getValorDescontoBonificacao = () => {
        let valorDescontoBonificacao = 0.0
        this.state.transactions.forEach(transaction => {
            if(transaction.tipoProduto && (transaction.tipoProduto.chave === ConstantsUtil.tipoProdutoBonificacaoChave) ){
                valorDescontoBonificacao += transaction.valor
            }
        })
        return GeneralServices.formatTo2CasasDecimais(valorDescontoBonificacao)
    }

    isNFDevolucao = () => {
        return (this.props.NFToValidate && this.props.NFToValidate.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel)
    }

    valorDevolucaoTooltip = () => {
        if(this.props.insideValidateNFDialog){
            return "Valor da Nota Fiscal de Devolução" +
                    `${this.props.NFToValidate.notaFiscalDevolucao ? ` (Número ${this.props.NFToValidate.notaFiscalDevolucao.numero})` : ", se houver"}.`            
        }
        else{
            return 'Valor de Devolução, se houver';
        }
    }

    hidePedidoCompraDialog = () => {
        this.setState({displayPedidoCompraDialog: false})
    }

    callRemovePedidosLink = () => {
        this.setState({displayConfirmationRemovePedidosLink: true})
    }

    confirmRemovePedidos = () => {
        this.setState({displayConfirmationRemovePedidosLink: false})
        this.unlinkAll()
        this.hidePedidoCompraDialog()
    }

    unlinkAll = async () => {
        await this.setState({pedidosLinkadosId: []})
        // console.log("unlinkAll: ", this.state.pedidosLinkadosId)
   }

    confirmLinkPedidosCompra = () => {
        this.hidePedidoCompraDialog()
    }

    linkPedidosCompra = pedidos => {
        pedidos = pedidos.filter(pedido => pedido.link)
        let pedidosLinkadosId = pedidos.map(pedido => pedido.id)
        this.setState({pedidosLinkadosId})
        // console.log("pedidosLinkadosId: ", pedidosLinkadosId)
    }

    getPedidosLinkados = () => {
        if(this.state.buscandoPedidosComprasLinkados){
            return 'Buscando ...'
        }

        if(this.state.pedidosLinkadosId.length === 0){
            return "Não encontrado."
        }

        return this.state.pedidosLinkadosId.map(id => `#${id}`).join(", ")
    }

    render() {

        const renderNumeroAndComplementoHistorico = () => {
            if(!this.props.insideValidateNFDialog) {
                return (
                    <>
                    <div className="col-md-2">
                        <label htmlFor="date">N° do Documento (Opcional)</label>
                        <input
                            type="number"
                            className={"form-control " }
                            value = {this.state.numeroDocumento}
                            name="numeroDocumento"
                            onChange={this.handleNumeroChange}
                            id="nomeTipoDeRecebimento"
                            // disabled={this.props.provisao && this.props.provisao.notaFiscal}
                        />
                    </div>

                    <div className="col-md-3">
                    <label htmlFor="icon">Complemento de Histórico (Opcional)</label>
                        <input
                            type="text"
                            className={"form-control "}
                            value = {this.state.complementoHistorico}
                            name="complementoHistorico"
                            onChange={this.handleChange}
                        />
                    </div>
                    </>
                )
            }            
        }

        const renderValorTotalNF = () => {
            if(!this.props.insideValidateNFDialog && !this.props.emprestimo) {
                return (
                    <>
                    <div className="col-md-12">

                    <div className="row">
                        <div className="col-md-2">
                            <label>Valor Total</label>
                        </div>
                        <div className="col-md-2">
                        </div>
                        {renderLabelValorAcrescimoDesconto()}
                        {renderLabelBonificacao()}
                        {renderLabelDevolucao()}
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            <InputNumber 
                                ref={this.inputValorRef}
                                className={this.state.inputValorTotalNFErrorClass}
                                name="valorTotalNF"
                                value={this.state.valorTotalNF}
                                onValueChange={this.handleValorChange}
                                // onKeyDown={this.handleKeyPress}
                                mode="decimal" locale="pt-BR" minFractionDigits={2}
                                // disabled={this.props.provisao && this.props.provisao.notaFiscal}
                            />
                        </div>
                        {renderAcrescimoDescontoComponent()}
                        {renderValorDescontoBonificacao()}
                        {renderValorDescontoDevolucao(this.state.valorDescontoPorDevolucao)}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                        <small id="valorError" className="p-error">{this.state.inputValorTotalNFErrorClass ? 'Informe o valor' : ''}</small>
                        </div>
                    </div>  
                    </div>
                    <br />
                    </>
                )
            }
        }

        const renderAcrescimoDescontoComponent = () => {
            if(!this.isNFDevolucao() && !this.props.isNFSaida)
            return (
                <>
                    <div className='col-md-2'>
                    <SelectMenu
                        id="selectAcrescimoDesconto"
                        className={"form-control " }
                        // ref={this.tipoDeLancamentoInputRef}
                        name="selectAcrescimoDesconto"
                        list={ConstantsUtil.acrescimoDescontoSelectList(true)}
                        value={this.state.selectAcrescimoDesconto}
                        onChange={this.handleSelectAcrescimoDescontoChange}
                        // disabled={this.props.fromOFX}
                    /> 
                    </div>
                    {renderValorAcrescimoDesconto()}                
            </>
            )
        }

        const renderValorTotalNFInfo = () => {
            if(this.props.insideValidateNFDialog) {
                return (
                    <>
                        <div className='col-md-12'>
                        <div className='row'>
                        <div className='col-md-3'>
                            <Button
                                label={`Valor Total da NF: ${GeneralServices.showFormattedIfNotNull( Math.abs(this.props.NFToValidate.valorTotal), true)}`}
                                style={{maxHeight: '1.5rem', width: '15rem'}}
                            />
                            <TooltipButton
                                tooltip = "Copiar Valor Total"
                                icon="pi pi-copy"
                                className="p-button-rounded p-button-primary p-mr-2 right-button"
                                style={ {maxHeight: '25px', maxWidth: '25px'} }
                                onClick={() => {
                                    navigator.clipboard.writeText(this.props.NFToValidate.valorTotal.toString().replace(".", ","))
                                    popUp.infoPopUp(`Valor ${GeneralServices.showFormattedIfNotNull(this.props.NFToValidate.valorTotal, true)} copiado!`)
                                }}
                            />
                        </div>
                        {renderAcrescimoDescontoComponent()}
                        {renderValorDescontoBonificacao()}
                        {renderValorDescontoDevolucao(this.props.NFToValidate.valorDescontoPorDevolucao)}
                        </div>
                        </div>
                    </>
                )
            }
        }

        const renderValorAcrescimoDesconto = () => {
            if(this.state.selectAcrescimoDesconto) {
                return (
                    <>
                    <div className='col-md-2'>
                    <InputNumber 
                        className={this.state.inputValorAcrescimoDescontoErrorClass}
                        name="valorAcrescimoDesconto"
                        value={this.state.valorAcrescimoDesconto}
                        onValueChange={this.handleNumeroChange}
                        // onKeyDown={this.handleKeyPress}
                        mode="decimal" locale="pt-BR" minFractionDigits={2} maxFractionDigits={2}
                        placeholder='Valor'
                    />
                    <div className="row">
                        <div className="col-md-12">
                        <small id="valorError" className="p-error">{this.state.inputValorAcrescimoDescontoErrorClass ? `${ConstantsUtil.informeValorErrorMenssage} do Acréscimo/Desconto`: ""}</small>
                        </div>
                    </div>
                    </div>

                    </>
                )
            }
        }

        const renderValorDescontoBonificacao = () => {
            if(!this.isNFDevolucao() && !this.props.isNFSaida)
            return (
                <div className='col-md-2'>
                <InputNumber 
                    value={this.getValorDescontoBonificacao()}
                    mode="decimal" locale="pt-BR" minFractionDigits={2} maxFractionDigits={2}
                    placeholder='Valor'
                    disabled
                />
                </div>                
            )
        }

        const renderValorDescontoDevolucao = (valorDescontoPorDevolucao) => {
            if(!this.isNFDevolucao() && !this.props.isNFSaida)
            return (
                <div className='col-md-2'>
                <InputNumber
                    name="valorDescontoPorDevolucao"
                    value={valorDescontoPorDevolucao}
                    onValueChange={this.handleValorChange}
                    mode="decimal" locale="pt-BR" minFractionDigits={2} maxFractionDigits={2}
                    placeholder='Valor devolução'
                    disabled={this.props.insideValidateNFDialog}
                />
                </div>                
            )
        }

        const renderPagamentoLabel = () => {
            if(this.props.insideValidateNFDialog){
                return (
                    <div className='row'>
                    <br />
                    <div className='col-md-2'>
                        <h5>Pagamento</h5>
                    </div>
                    <div className='col-md-3'>
                    </div>
                    {renderDemaisLabels()}
                    </div>
                )
            }
        }

        const renderLabelValorAcrescimoDesconto = () => {
            if(this.state.selectAcrescimoDesconto){
                return (
                    <>
                        <div className='col-md-2'>
                            <label>Valor do Acréscimo/Desconto</label>
                        </div>
                    </>
                )
            }
        }

        const renderDemaisLabels = () => {
            return (
                <>
                    {renderLabelValorAcrescimoDesconto()}
                    {renderLabelsBonificacaoDevolucao()}
                </>                
            )
        }

        const renderLabelBonificacao = () => {
            if(!this.props.isNFSaida)
            return (
                <div className='col-md-2'>

                    <label>Valor da Bonificação</label>
                    <TooltipButton
                        tooltip={
                            "Somatório do valor dos produtos marcados como \"Bonificação\" abaixo."
                        }
                        tooltipOptions={{
                            className: 'custom-tooltip',
                            position: 'top'
                        }}
                        icon={<i className="pi pi-question" style={{fontSize: '0.8em'}}></i>}
                        style ={{maxHeight: '25px', maxWidth: '25px', marginLeft: '0.5em', marginBottom: '0.3em'}}
                        className="p-button-rounded p-mr-2"
                    />   
                </div>
            )
        }

        const renderLabelDevolucao = () => {
            if(!this.props.isNFSaida)
            return (
                <div className='col-md-2'>
                    <label>Valor da Devolução</label>
                    <TooltipButton
                        tooltip={this.valorDevolucaoTooltip()}
                        tooltipOptions={{
                            className: 'custom-tooltip',
                            position: 'top'
                        }}
                        icon={<i className="pi pi-question" style={{fontSize: '0.8em'}}></i>}
                        style ={{maxHeight: '25px', maxWidth: '25px', marginLeft: '0.5em', marginBottom: '0.3em'}}
                        className="p-button-rounded p-mr-2"
                    />
              </div>
            )
        }

        const renderLabelsBonificacaoDevolucao = () => {
            if(!this.isNFDevolucao())
            return (
                <>
                    {renderLabelBonificacao()}
                    {renderLabelDevolucao()}
                </>
            )   
        }        

        const renderQuantidadeParcelasComponent = () => {
            if(!this.props.isNFSaida)
            return (
                <QuantidadeParcelasComponent
                    ref={this.quantidadeParcelasComponentRef}
                    provisao={this.props.NFToValidate ? this.props.NFToValidate.provisao : null}
                    NF={this.props.NFToValidate ? this.props.NFToValidate : null}
                    valorTotalProvisao={this.getValorTotal()}
                    valorAcrescimoDesconto={this.getRealValorAcrescimoDesconto()}
                    valorDescontoBonificacao={this.getValorDescontoBonificacao()}
                    valorDescontoDevolucao={this.props.NFToValidate ? this.props.NFToValidate.valorDescontoPorDevolucao : this.state.valorDescontoPorDevolucao}
                    insideDialog={this.props.insideValidateNFDialog}
                />
            )
        }

        const renderPagamento = () => {
            if(this.props.insideValidateNFDialog){
                return renderQuantidadeParcelasComponent()
            }
            return (
                <div className='col-md-12'>
                    {renderQuantidadeParcelasComponent()}
                </div>
            )

        }

        const renderInputChooseFornecedor = () => {
            if(!this.props.insideValidateNFDialog && !this.props.isNFSaida){
                return (
                    <>
                    <div
                        className = "col-md-3"
                    >   
                        <InputChooseFornecedor
                            noHTMLFormat
                            selectedFornecedorLabel={this.state.fornecedor.nome}
                            handleSelectionFornecedorChange={this.handleSelectionFornecedorChange}
                            inputFornecedorErrorClass={this.state.inputFornecedorErrorClass}
                        />
                    </div>
                    <br />
                    </>
                )
            }            
        }

        const renderQuantidadeItens = () => {
            if(GeneralServices.isEmptyObject(this.state.fornecedor) && !this.props.isNFSaida){
                return;
            }
            let colMd = 3
            if(this.props.insideValidateNFDialog){
                colMd = 5
            }            
            return (
                // <div className='row'>
                <div className = {`col-md-${colMd}`}>
                <FormGroup label = "Quantidade de Itens">
                    <input 
                        type="number"
                        id="inputQtdItens"
                        className={"form-control " + this.state.inputQtdItensErrorClass}
                        name="qtdItens"
                        value = {this.state.qtdItens}
                        onChange={this.handleQuantidadeItensChange}
                        placeholder="Digite a quantidade de Itens"
                            />
                    <div className="invalid-feedback">Informe a quantidade de Itens</div>
                </FormGroup>
            </div>
            )
        }

        const renderPedidosCompraDialogFooter = () => {
            return (
                <div>
                    <Button
                        autoFocus
                        label="Confirmar"
                        icon="pi pi-check"
                        onClick={this.confirmLinkPedidosCompra}
                    />
                    
                    <Button
                        label="Remover todos os pedidos linkados"
                        className="p-button-danger"
                        icon="pi pi-trash"
                        onClick={this.callRemovePedidosLink}
                        disabled={!this.state.pedidosLinkadosId.length}
                    />
                    
                    <Button
                        label="Fechar"
                        className="p-button-text"
                        icon="pi pi-times"
                        onClick={this.hidePedidoCompraDialog}
                    />
                </div>
            );
        }

        const renderRemovePedidosLinkConfirmationFooter = () => {
            return (
                <div>
                    <Button
                        autoFocus
                        label="Confirmar"
                        icon="pi pi-check"
                        onClick={this.confirmRemovePedidos}
                    />
                    <Button
                        label="Cancelar"
                        className="p-button-text"
                        icon="pi pi-times"
                        onClick={() => this.setState({displayConfirmationRemovePedidosLink: false})}
                    />
                </div>
            );
        }

        const renderConfirmRemovePedidosLinkDialog = () => {
            return(
                <Dialog
                    header="Remover Links"
                    visible={this.state.displayConfirmationRemovePedidosLink}
                    modal = {true} //congela restante da tela
                    style={{ width: '350px' }}
                    footer={renderRemovePedidosLinkConfirmationFooter()}
                    onHide={() => this.setState({displayConfirmation: false})}>
                    <div className="confirmation-content row" style={{marginLeft: '10px'}}>
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem', marginRight: '10px'}} />
                        <div style={{marginBottom: '10px'}}> Deseja realmente remover os links? </div>
                    </div>
                </Dialog>
                
            )
        }

        const renderPreValidarButton = () => {
            if(GeneralServices.isTelaPreValidacaoNFs()){
                return(
                    <Button
                        label='Pré-Validar'
                        icon='pi pi-check'
                        className='p-button-success'
                        style={{maxWidth: '300px'}}
                        onClick={this.props.callSave}
                    />
                )
            }
        }

        const renderDivVaizaColMd6 = () => {
            return (<div className='col-md-6'></div>);
        }

        const renderLinkPedidosCompra = () => {

            if(window.location.pathname === ConstantsUtil.lancamentoManualNFPathName){
                return(<></>)
            }

            if(!this.state.possuiIntegracaoApiPedidosCompra){
                return renderDivVaizaColMd6()
            }

            if(this.props.NFToValidate && this.props.NFToValidate.tipo !== ConstantsUtil.entradaLabel){
                return renderDivVaizaColMd6()
            }

            if(this.props.isNFSaida){
                return renderDivVaizaColMd6()
            }
            
            if(this.state.displayPedidoCompraDialog){
                return (
                    <Dialog
                        className="sem-header"
                        visible={this.state.displayPedidoCompraDialog}
                        modal
                        style={{ width: '95%' }}
                        onHide={this.hidePedidoCompraDialog}
                        footer={renderPedidosCompraDialogFooter()}
                    >
                        <ValidacaoPedidosCompra
                            insideDialog
                            dataInicial = {this.props.NFToValidate ? this.props.NFToValidate.dhEmi.split(" - ")[0] : null}
                            scrollHeight="200px"
                            link={this.linkPedidosCompra}
                            pedidosLinkadosId={this.state.pedidosLinkadosId}
                        />
    
                    </Dialog>
                )
            }
            else{
                return (
                    <>
                        <div className='col-md-3'>
                        <Button
                            label={`Linkar com Pedidos de Compra`}
                            icon="pi pi-link"
                            style={{
                                marginBottom: '1rem',
                                maxHeight: '1.5rem',
                                width: '20rem'
                            }}
                            onClick={() => {
                                // console.log(this.props.NFToValidate)
                                this.setState({displayPedidoCompraDialog: true})
                            }}
                        />
                        </div>

                        <div className='col-md-3'>
                        <input
                            type="text"
                            readOnly
                            className={"form-control "}
                            value = {this.getPedidosLinkados()}
                            name="pedidosLinkados"
                            onClick={() => this.setState({displayPedidoCompraDialog: true})}
                            disabled={this.state.buscandoPedidosComprasLinkados}
                        />
                        </div>
                        
                    </>
                )
            }
        }

        const renderDataHoraEntrada = () => {
            if(!GeneralServices.isTelaPreValidacaoNFs())
            return(
                <>
                    <div className = {this.getColMdClasses().dataEntrada}>
                    <CustomCalendar
                        label={`Data de ${this.props.isNFSaida ? "Saída" : "Entrada"}`}
                        ref={this.dateInputRef}
                        id="dataEntradaOuSaida"
                        htmlFor="icon"
                        name="dataEntrada"
                        value={this.state.dataEntradaView}
                        noHTMLFormat
                        onChange={this.handleDateChange}
                        inputDateErrorClass={this.state.inputDateErrorClass}
                        errorDateMessage={this.state.errorDateMessage}
                    />
                    </div>            

                    <div className = {this.getColMdClasses().horarioEntrada}>
                        <label htmlFor="hour">{`Horário de ${this.props.isNFSaida ? "Saída" : "Entrada"}`}</label>
                            <InputMask
                                id="hour"
                                name="hour"
                                className={"form-control " + this.state.inputHourErrorClass }
                                mask="99:99"
                                value={this.state.hour}
                                placeholder="hh:mm"
                                onChange={this.handleHourChange}
                                // onKeyPress={this.handleKeypress}
                                // disabled={!this.state.habilitaBusca}
                            />
                            <small id="hourErrorNotice" className="p-error">{this.state.errorHourMessage}</small>
                    </div>
                </>
            )
        }

        const renderLinkPedidosCompraEBotaoPreValidar = () => {
            return(
                <div className='row'>

                    {renderLinkPedidosCompra()}

                    <div className='col-md-6'>
                    <div className='alinha-direita-conteudo-div'>
                        {renderPreValidarButton()}
                    </div>
                    </div>

                </div>
            )
        }

        return (

            <>
                <>
                <div className='col-md-12'> 
                    
                    {renderLinkPedidosCompraEBotaoPreValidar()}
                    {renderConfirmRemovePedidosLinkDialog()}
                
                <div className='row'>

                    {renderDataHoraEntrada()}
                    {renderNumeroAndComplementoHistorico()}

                </div>
                </div>

                <br/>
                {renderValorTotalNF()}
                {renderPagamentoLabel()}

                {renderValorTotalNFInfo()}

                {renderPagamento()}

                {renderInputChooseFornecedor()}

                {renderQuantidadeItens()}

                <ItensNFComponent
                    fornecedor={this.state.fornecedor}
                    produtosCompraList={this.state.produtosCompraList}
                    produtosPropriosList={this.state.produtosPropriosList}
                    isNFSaida={this.props.isNFSaida}
                    emprestimo={this.props.emprestimo}
                    searchProdutosCompra={this.searchProdutosCompra}
                    transactions={this.state.transactions}
                    insideValidateNFDialog={this.props.insideValidateNFDialog}
                    forceProductListUpdate={this.state.forceProductListUpdate}
                    doneForceUpadte={() => this.setState({forceProductListUpdate: false})}
                    handleSelectionProductChange={this.handleSelectionProductChange}
                    handleTipoProdutoChange={this.handleTipoProdutoChange}
                    handleQuantidadeItemLoopChange={this.handleQuantidadeItemLoopChange}
                    handleValorItemLoopChange={this.handleValorItemLoopChange}
                />

                </>
            </>
      
        )
    }


}

export default DadosNFComponent